import { render, staticRenderFns } from "./fengren.vue?vue&type=template&id=417e2ce6&scoped=true&"
import script from "./fengren.vue?vue&type=script&lang=js&"
export * from "./fengren.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417e2ce6",
  null
  
)

export default component.exports